import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import LeadForm from "../../src/components/LeadForm/LeadForm";
import { UserContext } from "../App"; // prilagodi putanju
import { getConsent } from "../analytics/tracker"; 

export default function Upload() {
  const { t } = useTranslation();
  const { user } = useContext(UserContext);
  console.log("UPLOAD user:", user);

  const prefill = user
    ? {
        name: user.displayName || user.name || "",
        email: user.email || "",
        phone: user.phoneNumber || "",
      }
    : undefined;

  return (
    <div className="max-w-3xl mx-auto p-4">
      <h2 className="text-3xl font-bold text-primary-light dark:text-primary-dark mb-4">
        💡 {t("upload_idea_title")}
      </h2>

      <p className="mb-4 text-text-light/80 dark:text-text-dark/80">
        {t("upload_idea_subtitle", "Send us your idea and attachments, and we’ll get back to you.")}
      </p>

      <LeadForm
        mailserverApi="https://modularobjects.com/mailserver"
        context={{ page: "upload", authed: !!user, uid: user?.uid || null }}
        allowAttachments={true}
        prefill={prefill}
        lockPrefilled={{ email: true }} // opciono: email da se ne menja
        initialMessage={t(
          "upload_initial_message",
          "Hello! I’d like to submit an idea. Please contact me with next steps."
        )}
        onSuccess={({ apiResult, error }) => {
  if (error) return;
  if (!(apiResult?.ok || apiResult?.needsVerification)) return;

  track(EV.LEAD_SUBMIT_SUCCESS, {
    ...getConsent(),
    contact_id: apiResult?.contactId || apiResult?.contact_id || null,
    metadata: {
      page: "upload",
      surface: "lead_form",
      authed: !!user,
      uid: user?.uid || null,
      ok: !!apiResult?.ok,
      needsVerification: !!apiResult?.needsVerification,
    },
  });

          if (apiResult?.ok || apiResult?.needsVerification) {
            window.dataLayer?.push({
              event: "upload_lead_submit_success",
              ok: !!apiResult?.ok,
              needsVerification: !!apiResult?.needsVerification,
            });
          }
        }}
        conversion={() => {
          window.gtag?.("event", "generate_lead", { value: 1.0, currency: "RSD" });
        }}
      />
    </div>
  );
}